import { gql } from '@apollo/client';

export default gql`
  query getRequests(
    $departmentId: String
    $employeeId: String
    $resourseId: String
    $customerId: String
    $contractId: String
    $stepId: Int
    $start: Date
    $end: Date
    $due: Boolean
    $type: String
  ) {
    getRequests(
      departmentId: $departmentId
      employeeId: $employeeId
      resourseId: $resourseId
      customerId: $customerId
      contractId: $contractId
      stepId: $stepId
      start: $start
      end: $end
      due: $due
      type: $type
    ) {
      ok
      error
      data {
        _id
        branch
        title
        desc
        time
        locationLink
        address
        autoNo
        docNo

        stepId
        stepTime
        stepName
        stepNameAr
        stepDesc
        stepUser
        stepUserName
        stepColor
        steps

        paymentType

        customerId
        customerName
        customerNameAr
        customerPhone

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr

        resourseId
        resourseName
        resourseNameAr

        contractId
        contractName
        contractNameAr

        attachments

        userId
        createdAt
        updatedAt
      }
    }
  }
`;
